/*
 * TEMPLATE WHATSAPP — the message bodies the invoice/nota sender and the bulk reminder queue start from.
 * Editable in Pengaturan (shared via the app-state store, key 'airro_wa_templates'); placeholders are
 * filled at send time, unknown ones are left as typed.
 *
 * "Tagihan baru" sends the DOCUMENT's total ({total}) — not the customer's whole sisa bon. A stored copy
 * of the old default body (never edited) follows the new default; an edited one is kept verbatim.
 *
 * ISOMORPHIC: tests require it; the bundle exposes window.WATPL. Dependency-free.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;   // server (CommonJS)
  if (root) root.WATPL = api;                                                 // browser (global)
})(typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : this), function () {
  'use strict';

  const PLACEHOLDERS = ['nama', 'kode', 'sisa_bon', 'periode', 'jatuh_tempo', 'no_invoice', 'link', 'nama_usaha', 'total'];

  const DEFAULTS = [
    { id: 'tagihan', name: 'Tagihan baru', body: 'Halo {nama}, berikut tagihan air dari {nama_usaha}.\nNo. {no_invoice} · Periode {periode}\nTotal ditagih: {total}\nJatuh tempo: {jatuh_tempo}\n\nRincian & simpan PDF: {link}\n\nTerima kasih 🙏' },
    { id: 'nota', name: 'Nota', body: 'Halo {nama}, berikut nota {no_invoice} dari {nama_usaha}.\nTotal: {total}\n\nRincian & simpan PDF: {link}\n\nTerima kasih 🙏' },
    { id: 'pengingat', name: 'Pengingat', body: 'Halo {nama}, mengingatkan sisa bon Anda di {nama_usaha} sebesar {sisa_bon} (No. {no_invoice}), jatuh tempo {jatuh_tempo}.\n\nRincian: {link}\n\nTerima kasih 🙏' },
    { id: 'riwayat', name: 'Riwayat transaksi (bukan tagihan)', body: 'Halo {nama}, berikut riwayat transaksi air Anda di {nama_usaha} untuk periode {periode}.\nNo. {no_invoice}\n\nLihat rincian: {link}\n\n(Ini bukan tagihan, hanya rekap.)' },
    { id: 'terimakasih', name: 'Terima kasih', body: 'Terima kasih {nama} 🙏 Pembayaran Anda di {nama_usaha} telah kami terima. Sisa bon saat ini: {sisa_bon}.\n\nRincian: {link}' },
    { id: 'kartu_galon', name: 'Kartu Galon', body: 'Halo {nama}, berikut Kartu Galon Anda dari {nama_usaha}: catatan galon kami yang ada di tempat Anda, lengkap dengan foto setiap hitungan dan pengiriman.\n{link}' },
  ];

  // Default bodies shipped before — a stored template still holding one was never edited.
  const LEGACY_BODIES = {
    tagihan: 'Halo {nama}, berikut tagihan air dari {nama_usaha}.\nNo. {no_invoice} · Periode {periode}\nSisa bon: {sisa_bon}\nJatuh tempo: {jatuh_tempo}\n\nRincian & simpan PDF: {link}\n\nTerima kasih 🙏',
  };

  // Merge stored (edited) templates over the defaults, keeping order + any custom additions.
  function merge(stored) {
    const arr = Array.isArray(stored) ? stored : [];
    const byId = {}; arr.forEach((t) => { if (t && t.id) byId[t.id] = t; });
    const out = DEFAULTS.map((d) => {
      const s = byId[d.id];
      if (!s) return d;
      const m = Object.assign({}, d, s);
      if (LEGACY_BODIES[d.id] != null && s.body === LEGACY_BODIES[d.id]) m.body = d.body;
      return m;
    });
    arr.forEach((t) => { if (t && t.id && !out.some((o) => o.id === t.id)) out.push(t); });
    return out;
  }

  // Fill {placeholders}; leaves unknown tokens untouched, blanks missing values. Never throws.
  function render(body, ctx) {
    return String(body || '').replace(/\{(\w+)\}/g, (m, k) => (ctx && ctx[k] != null) ? String(ctx[k]) : (PLACEHOLDERS.includes(k) ? '' : m));
  }

  const mentionsSisaBon = (body) => /\{sisa_bon\}/.test(String(body || ''));

  return { PLACEHOLDERS, DEFAULTS, LEGACY_BODIES, merge, render, mentionsSisaBon };
});
